import React from 'react'
import { useIntl } from 'react-intl'
import { useDocuments } from 'contexts/documents'
import { useCategories } from 'pages/documents/utilities'
import Modal from 'modals/dialog'
import Form from 'components/form/controller'
import SelectField from 'components/form/field/select'
import Status from './status'
import Actions from './actions'

const BulkEditDocumentCategory = ({ act, failed, progress, dismiss, salt }) => {
    const { formatMessage } = useIntl()

    const { getEditableSelection } = useDocuments()
    const { categories } = useCategories()

    const selection = getEditableSelection()

    const byUsage = (progress.total === 1) ?
        { [selection[0].category ?? 'none']: 1 } :
        selection.reduce((accumulator, { category }) => {
            category = category ?? 'none'

            if(!accumulator[category]) {
                accumulator[category] = 1
            } else {
                accumulator[category]++
            }

            return accumulator
        }, {})

    const mostCommon = (progress.total === 1) ?
        { value: selection[0].category ?? 'none', count: 1 } :
        Object.entries(byUsage)
            .reduce((accumulator, [value, count]) => {
                if(count > accumulator.count) {
                    return { value, count }
                }

                return accumulator
            }, { value: 'none', count: 0 })

    return (
        <Form
            layout="vertical"
            onSubmit={act}
            key={`${salt}:bulk:category`}>
            <Modal.Body>
                <SelectField
                    salt={salt}
                    label={formatMessage({
                        id: 'noun_category',
                        defaultMessage: 'Category'
                    })}
                    name="category"
                    field={{
                        value: ((mostCommon.count > 1 || progress.total === 1) && mostCommon.count / progress.total >= .5) ?
                            mostCommon.value :
                            'none',
                        required: true,
                        include: 'always',
                        allowEmptyOption: false
                    }}
                    options={categories.map(category => ({
                        ...category,
                        key: category.value
                    }))}
                    enabled={progress.processed === 0} />
                <Status
                    progress={progress}
                    failed={failed} />
            </Modal.Body>
            <Actions
                progress={progress}
                dismiss={dismiss} />
        </Form>
    )
}

export default BulkEditDocumentCategory